<template>
  <div>
    <section>
      <div class="container is-max-hd">
        <div class="columns">
          <div class="column is-two-thirds">
            <div class="box" style="position: relative">
              <div class="notification is-warning">
                <p>
                  This insurance discovery has expired. Please create a new one to get up-to-date
                  information.
                </p>
              </div>
              <div class="buttons">
                <b-button
                  type="is-primary"
                  icon-left="plus"
                  @click="$router.push({ name: 'InsuranceDiscoveryCreate' })"
                >
                  Create New Insurance Discovery
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'InsuranceDiscoveryExpired',
  props: {
    insuranceDiscoveryId: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.box {
  padding: 1.5rem;
}

.buttons {
  margin-top: 1rem;
}
</style>
